export { default as FeaturesSectionItem } from './FeaturesSectionItem';
